import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import UserInfo from '../../containers/UserInfo';
import HelpNavMenu from '../../containers/HelpNavMenu';
import Notifications from '../../containers/Notifications';
import * as constants from '../../containers/Authorization/constants';
import Grid from '../Grid';
import SearchBar from '../../containers/SearchBar';
import './styles.css';
import SearchToggleButton from '../SearchToggleButton';
import PageCaption from './page-caption';
import Image from '../Image';
import intersectImg from './counselor-community.png';
import IntersectSvgImg from './counselor-community-by-powerschool-rgb-gray-teal.svg';
import FeatureDisabled from '../FeatureDisabled';
import { withEnabledFeatures } from '../../utils/features';
import { DISABLE_LEGACY_COMMUNITY } from '../../containers/Authorization/constants';

export class SiteHeader extends React.PureComponent {
  static propTypes = {
    authenticated: PropTypes.bool,
    isNavianceLogin: PropTypes.bool,
    enabledFeatures: PropTypes.array,
  };

  static defaultProps = {
    enabledFeatures: [],
  };

  state = { showSearch: false };

  toggleSearch = () => {
    this.setState((prevState) => ({ showSearch: !prevState.showSearch }));
  };

  render() {
    const { authenticated, isNavianceLogin } = this.props;
    const { showSearch } = this.state;
    const isDisabledLegacyCommunity = this.props.enabledFeatures?.includes(DISABLE_LEGACY_COMMUNITY);
    const renderSearchBar = (!isNavianceLogin || !isDisabledLegacyCommunity);
    return (
      <Grid>
        {authenticated && (
        <Grid.Row styleName="print" verticalAlign="middle">
          <Grid.Column width={6}>
            <Image src={intersectImg} alt="Intersect Logo" />
          </Grid.Column>
          <Grid.Column width={5}>
            <PageCaption className="hidden-mobile hidden-tablet" />
          </Grid.Column>
        </Grid.Row>
        )}
        {authenticated && (
        <Grid.Row styleName="no-print" verticalAlign="middle">
          <Grid.Column computer={5} mobile={7} tablet={8} />
          <Grid.Column width={8} only="computer" textAlign="right">
            { renderSearchBar && <SearchBar searchBoxId="global-computer-search-box" />}
          </Grid.Column>
          <Grid.Column computer={3} mobile={9} tablet={8} textAlign="right" styleName="align-right-icons">
            <SearchToggleButton
              className="hidden-computer"
              onClick={this.toggleSearch}
            />
            <HelpNavMenu />
            <FeatureDisabled anyOf={constants.DISABLE_LEGACY_COMMUNITY}>
              <Notifications />
            </FeatureDisabled>
            <UserInfo />
          </Grid.Column>
        </Grid.Row>
        )}
        {!authenticated && (
        <Grid.Row centered>
          <Grid.Column computer={5} mobile={11} tablet={8}>
            <Image src={IntersectSvgImg} alt="Intersect Logo" width="100%" height="100%" />
          </Grid.Column>
        </Grid.Row>
        )}
        { authenticated && showSearch && (
        <Grid.Row styleName="search-row-nav" only="tablet mobile">
          <Grid.Column styleName="search-row-nav-padding">
            {renderSearchBar && <SearchBar searchBoxId="global-mobile-search-box" />}
          </Grid.Column>
        </Grid.Row>
        )}
      </Grid>
    );
  }
}
export const SiteHeaderComponent = injectIntl(SiteHeader);
const SiteHeaderContainer = withEnabledFeatures(SiteHeaderComponent);
export default SiteHeaderContainer;
